import { StudentSubmissionStatusType } from "shared/types/studentTypes";

export const formatSubmissionStatus = (status: StudentSubmissionStatusType) => status === "rework-required" ? "Rework Required" : status.charAt(0).toUpperCase() + status.slice(1)
